import e from"./Panel.vue_vue&type=script&lang.js";import{render as t}from"./Panel.vue_vue&type=template&id=d32d57f8&lang.js";e.render=t,e.__file="src/components/Panel.vue";export default e;
//# sourceMappingURL=Panel.vue.js.map
